import axios from 'axios';
import { isServiceWorkerSupported } from '@core/lib/serviceWorker/serviceWorker';
import { compose, always } from '@core/lib/fp';
import { swInterceptor } from './sw-interceptor/sw-interceptor';
import { redirectInterceptor } from './redirect-interceptor/redirect-interceptor';
import { onFulfilled, onRejected } from './error-interceptor/error-interceptor';
import throttleAdapterEnhancer from './middlewares/throttleAdapterEnhancer';
import conditionalHeaders from './middlewares/conditionalHeaders';

/**
 * @param {Object} config
 * @returns {AxiosInstance}
 */
export default function({ baseURL, withCredentials = true, withXhrHeader = true, ...additionalParams }) {
  const enhanceAdapter = compose(
    throttleAdapterEnhancer,
    conditionalHeaders(always(withXhrHeader), {
      'X-Requested-With': 'XMLHttpRequest',
    }),
  );

  const axiosInstance = axios.create({
    baseURL,
    withCredentials,
    adapter: enhanceAdapter(axios.defaults.adapter),
    ...additionalParams,
  });

  axiosInstance.interceptors.response.use(onFulfilled, onRejected);

  axiosInstance.interceptors.response.use(redirectInterceptor);

  if (isServiceWorkerSupported()) {
    axiosInstance.interceptors.request.use(swInterceptor);
  }

  return axiosInstance;
}
